import React, { useState, useRef } from "react";
import { FaMicrophone, FaStop } from "react-icons/fa";
import { audioBufferToWav, blobToAudioBuffer, blobToBase64 } from "./audioUtils";

export const RecordAudioTestPreview = ({ onAudioRecorded, buttonSize = "20", iconSize = "10" }) => {
    const [isRecording, setIsRecording] = useState(false);
    const mediaRecorderRef = useRef(null);
    const audioChunksRef = useRef([]);
    const audioContextRef = useRef(null);

    const startRecording = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            const mediaRecorder = new MediaRecorder(stream);
            mediaRecorderRef.current = mediaRecorder;
            audioChunksRef.current = [];

            // Crear AudioContext si no existe
            if (!audioContextRef.current) {
                audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
            }

            mediaRecorder.ondataavailable = (event) => {
                if (event.data.size > 0) {
                    audioChunksRef.current.push(event.data);
                }
            };

            mediaRecorder.onstop = async () => {
                // Crear blob temporal con el formato del navegador
                const tempBlob = new Blob(audioChunksRef.current, { type: 'audio/webm' });

                try {
                    // Convertir a AudioBuffer
                    const audioBuffer = await blobToAudioBuffer(tempBlob, audioContextRef.current);

                    // Convertir AudioBuffer a WAV
                    const wavBlob = audioBufferToWav(audioBuffer);

                    // Convertir WAV Blob a Base64
                    const base64String = await blobToBase64(wavBlob);

                    console.log("Audio convertido a WAV y codificado en Base64");

                    // Enviar el audio mediante el callback
                    if (onAudioRecorded) {
                        onAudioRecorded(base64String);
                    }
                } catch (error) {
                    console.error("Error al convertir el audio a WAV:", error);
                    alert("Error al procesar el audio. Intenta nuevamente.");
                }

                // Detener todos los tracks del stream
                stream.getTracks().forEach(track => track.stop());
            };

            mediaRecorder.start();
            setIsRecording(true);
        } catch (error) {
            console.error("Error al acceder al micrófono:", error);
            alert("No se pudo acceder al micrófono. Por favor, verifica los permisos.");
        }
    };

    const stopRecording = () => {
        if (mediaRecorderRef.current && mediaRecorderRef.current.state !== "inactive") {
            mediaRecorderRef.current.stop();
            setIsRecording(false);
        }
    };

    const handleMicrophoneClick = () => {
        if (isRecording) {
            stopRecording();
        } else {
            startRecording();
        }
    };

    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
            margin: 0,
            padding: 0,
            boxSizing: 'border-box'
        }}>
            <button
                onClick={handleMicrophoneClick}
                style={{
                    width: `${buttonSize}px`,
                    height: `${buttonSize}px`,
                }}
                className={`
                    relative
                    rounded-full
                    flex items-center justify-center
                    transition-all duration-300
                    ${isRecording
                        ? 'bg-red-500 hover:bg-red-600 animate-pulse'
                        : 'bg-blue-500 hover:bg-blue-600'
                    }
                    shadow-lg hover:shadow-xl
                    transform hover:scale-105
                `}
                aria-label={isRecording ? "Detener grabación" : "Iniciar grabación"}
            >
                {isRecording ? (
                    <FaStop style={{ fontSize: `${iconSize}px` }} className="text-white" />
                ) : (
                    <FaMicrophone style={{ fontSize: `${iconSize}px` }} className="text-white" />
                )}

            </button>
        </div>
    );
};
